import $ from 'jquery'
import React from 'react'
import ReactDOM from 'react-dom'
import ClosureSurvey from './closure_survey'
import MessageNavigation from './components/MessageNavigation'
import MoreDetails from './components/MoreDetails'
import OnpageInlineEditor from './components/OnpageInlineEditor'
import Pagination from './components/Pagination'
import Phone from './components/Phone'
import JoraSignUpForm from './components/business/JoraSignUpForm'
import PricingSurvey from './components/business/PricingSurvey'
import MembershipEdit from './components/business/memberships/MembershipEdit'
import EditPricing from './components/business/profile/EditPricing'
import LightboxLocation from './components/business_directory/LightboxLocation'
import PaginateBusinessDirectory from './components/business_directory/PaginateBusinessDirectory'
import PaginateFeedback from './components/business_directory/PaginateFeedback'
import EoiAttachmentRow from './components/eoi/EoiAttachmentRow'
import { mountComponents, unmountComponents } from './mount'
import publish from './publish'

// The job wizards read SS.appFn from vendor.js while they load, so their modules evaluate only
// when application.js calls loadJobWizards, at the point where it used to require them.
const loadJobWizards = () => {
  const jobWizards = require('./job_wizards')

  publish({
    'SS.Job': jobWizards.Job,
    'SS.React.Base.GetQuotes': jobWizards.GetQuotes,
    'SS.React.Base.GetQuotesV2': jobWizards.GetQuotesV2,
    'SS.React.Base.LandingPageQuotesButton': jobWizards.LandingPageQuotesButton,
    'SS.React.JobWizard': jobWizards.JobWizard,
    'SS.React.JobWizardMobile': jobWizards.JobWizardMobile
  })
}

// Object.assign, not `window.jQuery = $`: vite.config.mjs injects the bundled jQuery for a literal
// `window.jQuery`, so that assignment would never reach window.
Object.assign(window, {
  $,
  jQuery: $,
  React,
  ReactDOM,
  SprocketsReact: { loadJobWizards, mountComponents, unmountComponents }
})

publish({
  'SS.React.Base.LightboxLocation': LightboxLocation,
  'SS.React.Base.MessageNavigation': MessageNavigation,
  'SS.React.Base.MoreDetails': MoreDetails,
  'SS.React.Base.OnpageInlineEditor': OnpageInlineEditor,
  'SS.React.Base.PaginateBusinessDirectory': PaginateBusinessDirectory,
  'SS.React.Base.PaginateFeedback': PaginateFeedback,
  'SS.React.Base.Pagination': Pagination,
  'SS.React.Base.Phone': Phone,
  'SS.React.Business.EditPricing': EditPricing,
  'SS.React.Business.JoraSignUpForm': JoraSignUpForm,
  'SS.React.Business.MembershipEdit': MembershipEdit,
  'SS.React.Business.PricingSurvey': PricingSurvey,
  'SS.React.ClosureSurvey.Modal': ClosureSurvey.Modal,
  'SS.React.Eoi.EoiAttachmentRow': EoiAttachmentRow
})
